import {
  useNavigate as useReactRouterNavigate,
  useLocation,
} from 'react-router-dom';

const MFE_BASE_PATH = '/pos-app';

/**
 * Custom navigation hook that handles MFE basename automatically
 * This ensures all navigation calls work correctly in MFE context
 */
export const useNavigate = () => {
  const navigate = useReactRouterNavigate();
  const location = useLocation();

  return (to: string | number, options?: any) => {
    if (typeof to === 'number') {
      // Handle back/forward navigation
      return navigate(to);
    }

    // Check if we're in MFE context (running under /pos-app)
    const isMFE =
      window.location.pathname.includes(MFE_BASE_PATH) ||
      location.pathname.includes(MFE_BASE_PATH);

    if (isMFE && to.startsWith('/') && !to.startsWith(MFE_BASE_PATH)) {
      // Add /pos-app prefix for absolute paths in MFE context
      return navigate(`${MFE_BASE_PATH}${to}`, options);
    }

    // Use original path for relative paths or already prefixed paths
    return navigate(to, options);
  };
};

export default useNavigate;
